import axios from 'axios'
import Utils from '@/common/Utils'
import store from '../store'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class FactoringCompanyService {
    static async getAll (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            const { data } = await axios.get(`${url}/v2/factoring-company`, { headers, params })
            return { items: data.items, count: data.count }
        } catch (error) {
            throw error
        }
    }

    static async getOne (id, params) {
        headers['Authorization'] = await Utils.setLocalToken()
        let { data } = await axios.get(`${url}/v2/factoring-company/${id}`, { headers, params })
        return data
    }

    static async getByRFC (params) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                let { data } = await axios.get(`${url}/factoringCompanyByRFC/`, { headers, params })
                resolve(data)
            } catch (error) {
                reject(error)
            }
        })
    }

    static async create (payload) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            payload.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.post(`${url}/v2/factoring-company/`, payload, { headers })
            return data
        } catch (error) {
            throw error.response
        }
    }

    static async update (payload) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
                payload.userId = store.getters.user ? store.getters.user.userId : null
                let { data } = await axios.put(`${url}/v2/factoring-company/${payload.id}`, payload, { headers })
                resolve(data)
            } catch (error) {
                reject(error)
            }
        })
    }

    static async comment (payload) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            payload.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}/v2/factoring-company/${payload.id}/comment`, payload, { headers })
            return data
        } catch (error) {
            throw error.response
        }
    }

    static async approve (payload) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            payload.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}/v2/factoring-company/${payload.id}/approve`, payload, { headers })
            return data
        } catch (error) {
            throw error.response
        }
    }

    static async reject (payload) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            payload.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}/v2/factoring-company/${payload.id}/reject`, payload, { headers })
            return data
        } catch (error) {
            throw error.response
        }
    }

    static async restrict (payload) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            payload.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}/v2/factoring-company/${payload.id}/restrict`, payload, { headers })
            return data
        } catch (error) {
            throw error.response
        }
    }

    static async uploadFile (file) {
        try {
            let formData = new FormData()
            formData.append('file', file)

            headers['Authorization'] = await Utils.setLocalToken()
            headers['Content-Type'] = 'multipart/form-data'

            let { data } = await axios.post(`${url}/factoringCompany/massive-update/file`, formData, { headers })
            headers['Content-Type'] = 'application/json'
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error.response)
        }
    }

    static async getDataFromFile (params) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                let { data } = await axios.get(`${url}/factoringCompany/massive-update/getDataFromFile`, { headers, params })
                resolve(data)
            } catch (error) {
                reject(error.response)
            }
        })
    }

    static async importDataFromFile (payload) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
                let { data } = await axios.post(`${url}/factoringCompany/massive-update/importDataFromFile`, payload, { headers })
                resolve(data)
            } catch (error) {
                reject(error.response)
            }
        })
    }
}
